import { v as bvVar } from 'bv';
import { locale } from '../services/i18n';

const footerConfig = bvVar('siteConfigs').footer || {};

const {
  numberLogosFirstRowMobile,
  partnerLogos = [],
  showLogo,
  showPartners: showPartnersConfig,
} = footerConfig;

const showPartners = showPartnersConfig && showPartnersConfig.includes(locale());

export {
  numberLogosFirstRowMobile,
  partnerLogos,
  showLogo,
  showPartners,
};
